import { Reveal } from "./Reveal";
import { toast } from "sonner";
import { Gift, UserPlus, Dumbbell, Share2 } from "lucide-react";

const steps = [
  { icon: UserPlus, title: "Refer a friend", text: "Send them your invite or just tell them to mention your name." },
  { icon: Dumbbell, title: "They start training", text: "Your friend joins any coaching or bootcamp package." },
  { icon: Gift, title: "You both win", text: "You each get a free week of training added to your plan." },
];

export default function Referral() {
  const share = async () => {
    const url = "https://getfitwithjc.com";
    const data = {
      title: "Getfitwithjeanclaude",
      text: "Train with Coach Jean Claude — refer me and we both get a free week!",
      url,
    };
    try {
      if (navigator.share) {
        await navigator.share(data);
      } else {
        await navigator.clipboard.writeText(`${data.text} ${url}`);
        toast("Link copied!", { description: "Share it with a friend to claim your free week." });
      }
    } catch {
      /* user cancelled share — no-op */
    }
  };

  return (
    <section id="referral" className="bg-[#050505] py-24 md:py-40 border-t border-[#222]" data-testid="referral">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <div className="border border-[#005EEA]/30 bg-[#0b0f1a] p-8 md:p-16 shadow-[0_0_80px_rgba(0,94,234,0.12)]">
          <Reveal>
            <p className="font-mono-accent text-[#005EEA] text-xs mb-4">Referral Program</p>
            <h2 className="font-display text-white text-4xl md:text-6xl lg:text-7xl leading-[0.9] max-w-3xl">
              Refer a friend.<br />You both get a <span className="text-[#005EEA]">free week.</span>
            </h2>
          </Reveal>

          <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10">
            {steps.map((s, i) => (
              <Reveal key={i} delay={i * 0.1}>
                <div className="flex flex-col gap-3" data-testid={`referral-step-${i}`}>
                  <div className="flex items-center gap-3">
                    <span className="font-display text-[#005EEA] text-3xl leading-none">0{i + 1}</span>
                    <s.icon className="text-white" size={22} />
                  </div>
                  <h3 className="font-display text-white text-xl leading-none">{s.title}</h3>
                  <p className="text-[#A0A0A0] text-sm leading-relaxed">{s.text}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.3}>
            <button
              onClick={share}
              className="mt-14 font-mono-accent text-xs bg-[#005EEA] text-white px-8 py-5 flex items-center gap-2 hover:bg-[#0047b3] transition-colors shadow-[0_0_30px_rgba(0,94,234,0.35)]"
              data-testid="referral-share-btn"
            >
              <Share2 size={15} /> Share &amp; claim your free week
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
